import { render, staticRenderFns } from "./notify.template.vue?vue&type=template&id=63f72d84&scoped=true&"
var script = {}
import style0 from "./notify.template.vue?vue&type=style&index=0&id=63f72d84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f72d84",
  null
  
)

export default component.exports